import { Optional } from "@/globalTypes";

export function getOptional<T>(
  elements: Optional<Array<T>>,
  index: number
): Optional<T> {
  return elements ? elements[index] : null;
}

type GTMEvent = {
  event: string;
  "login-method"?: string;
};

export function sendGTMEvent(event: GTMEvent, eventCallback: CallableFunction) {
  window.dataLayer = window.dataLayer || [];
  if (
    window.dataLayer.findIndex((event) => event["gtm.start"] !== undefined) > 0
  ) {
    window.dataLayer.push({
      ...event,
      eventCallback,
    });
  } else {
    window.dataLayer.push(event);
    eventCallback();
  }
}
